import { NgModule } from "@angular/core";

import { AwardsModule } from "./awards";
import { CategoriesModule } from "./categories";
import { CommonModule } from "./common";
import { CountriesModule } from "./countries";
import { DashboardModule } from "./dashboard";
import { DepartmentsModule } from "./departments";
import { DownloadTypesModule } from "./download-types";
import { DownloadsModule } from "./downloads";
import { EsportsSlidesModule } from "./esports-slides";
import { EsportsTeamsModule } from "./esports-teams";
import { FiltersModule } from "./filters";
import { HomeSliderModule } from "./home-slider";
import { LandingsModule } from "./landings";
import { ProductsModule } from "./products";
import { ResellersModule } from "./resellers";
import { SeriesModule } from "./series";
import { PagesModule } from "./pages";
import { MaterialModule } from "@atenea-cms";
import { FlexLayoutModule } from "@angular/flex-layout";

const ATENEA_BRAND_MODULES = [
  AwardsModule,
  CategoriesModule,
  CommonModule,
  CountriesModule,
  DashboardModule,
  DepartmentsModule,
  DownloadTypesModule,
  DownloadsModule,
  EsportsSlidesModule,
  EsportsTeamsModule,
  FiltersModule,
  HomeSliderModule,
  LandingsModule,
  ProductsModule,
  ResellersModule,
  SeriesModule,
  PagesModule,
  MaterialModule,
  FlexLayoutModule,
];

@NgModule({
  imports: ATENEA_BRAND_MODULES,
  exports: ATENEA_BRAND_MODULES,
})
export class AteneaBrandModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/atenea-brand.module.ts